(function($) {
    // Mobile dropdown functionality
    $('.filter-dropdown .filter-label').on('click keypress', function(e) {
        if (e.type === 'keypress' && e.which !== 13) return;
        
        const $this = $(this);
        $this.toggleClass('is-open');
        $this.siblings('.filter-buttons').toggleClass('is-open');
    });

    // Update dropdown label on mobile
    $('.filter-dropdown .filter-buttons .btn').on('click', function(e) {
        const $this = $(this);
        $this.closest('.filter-dropdown').find('.filter-label span').text($this.text());
    });

    // Close dropdown when clicking outside
    $(document).on('click', function(e) {
        if (!$(e.target).closest('.filter-dropdown').length) {
            $('.filter-buttons').removeClass('is-open');
            $('.filter-label').removeClass('is-open');
        }
    });
})(jQuery); 